'use client';

import config from '@packages/config';
import { redirect, usePathname } from 'next/navigation';

// root not found file for unknown non-localized routes
const RootNotFound = () => {
  const pathname = usePathname();
  redirect(`${config.i18n.defaultLocale.split('-')[0]}/${pathname}`);
};

// eslint-disable-next-line import-x/no-default-export
export default RootNotFound;
